<!--<ng-container style="margin-top:50px;">
  <div class="wrapper">
    <div class="container flex-grow-1 overflow-auto mt-5">

      <h5 class="mb-4 mt-2 p-1 text-center" style="font-size:19px !important">
        <span>Please review the information below and print your {{laborImaging || 'lab/imaging'}} order for your <strong>{{labOrderResponse?.lab_name || 'lab'}}</strong> visit.</span>
      </h5>

      <div class="row justify-content-center">
        <div class="col-md-6">

          <div class="card border">
            <div class="card-header bg-info font-weight-bold mb-0 p-3 text-white">
              <h5 class="fw-bold text-center mb-0" style="font-size:22px">
                {{laborImaging || 'lab/imaging'}} Order Details
              </h5>
            </div>

            <div class="card-body p-3">

              <div class="mb-2">
                <span style="font-size:17px">
                  <strong>Ordered By: </strong>
                  <a>{{labOrderResponse?.provid_fname}} {{labOrderResponse?.provid_lname || 'N/A'}}</a>
                </span>
              </div>

              <div class="mb-2">
                <span style="font-size:17px">
                  <strong>Patient Name: </strong>
                  <a>{{labOrderResponse?.first_name}} {{labOrderResponse?.last_name || 'N/A'}}</a>
                </span>
              </div>

              <div class="mb-2">
                <span style="font-size:17px">
                  <strong>Lab Address:</strong>
                  <a>
                    {{labOrderResponse?.lab_address || 'N/A'}},
                    {{labOrderResponse?.lab_city}},
                    {{labOrderResponse?.lab_state}} {{labOrderResponse?.lab_zip}}
                  </a>
                </span>
              </div>

              <div class="">
                <span style="font-size:17px">
                  <strong>Lab Phone:</strong> {{labOrderResponse?.lab_phone || 'N/A'}}
                </span>
              </div>

            </div>

          </div>
        </div>

      </div>

    </div>
  </div>

  <footer class="p-3">
    <div class="container p-0">
      <div class="row justify-content-center">
        <div class="col-lg-6 col-md-6 col-12" style="padding: 0px 30px 0px 30px">
          <button class="btn btn-primary w-100" type="button" (click)="generatePDF()">
            Print {{laborImaging || 'lab/imaging'}} Order
          </button>
        </div>
      </div>
    </div>
  </footer>

</ng-container>-->
<ng-container style="margin-top:50px;">
  <div class="wrapper">
    <div class="container mt-5">

      <!-- Page Title -->
      <h3 class="page-title text-center mb-4">
        Please review the information below and print your
        {{ laborImaging || 'lab/imaging' }} order for your
        <strong>{{ labOrderResponse?.lab_name || 'lab' }}</strong> visit.
      </h3>

      <div class="row justify-content-center">
        <div class="col-md-6">

          <!-- Card -->
          <div class="order-card shadow-sm">
            <div class="order-card-header">
              <h4 class="mb-0 text-white">
                {{ laborImaging || 'lab/imaging' }} Order Details
              </h4>
            </div>

            <div class="order-card-body">

              <div class="info-row">
                <label>Ordered By</label>
                <span>{{ labOrderResponse?.provid_fname }} {{ labOrderResponse?.provid_lname || 'N/A' }}</span>
              </div>

              <div class="info-row">
                <label>Order Date</label>
                <span>{{ labOrderResponse?.ordeR_DATE | date:'MM/dd/yyyy' }}</span>
              </div>

              <div class="info-row">
                <label>Patient Name</label>
                <span>{{ labOrderResponse?.first_name }} {{ labOrderResponse?.last_name || 'N/A' }}</span>
              </div>

              <div class="info-row">
                <label>Lab Address</label>
                <span>
                  {{ labOrderResponse?.lab_address || 'N/A' }},
                  {{ labOrderResponse?.lab_city }},
                  {{ labOrderResponse?.lab_state }} {{ labOrderResponse?.lab_zip }}
                </span>
              </div>

              <div class="info-row">
                <label>Lab Phone</label>
                <span>{{ labOrderResponse?.lab_phone || 'N/A' }}</span>
              </div>


            </div>
          </div>

        </div>
      </div>

    </div>
  </div>

  <!-- Print Button -->
  <footer class="p-3">
    <div class="container p-0">
      <div class="row justify-content-center">
        <div class="col-lg-6 col-md-6 col-12" style="padding: 0px 30px 0px 30px">
          <button class="btn btn-primary w-100" type="button" (click)="generatePDF()">
            Print {{laborImaging || 'lab/imaging'}} Order
          </button>
        </div>
      </div>
    </div>
  </footer>
</ng-container>




<div data-backdrop="static" data-keyboard="false" class="modal modal-md collapse" id="invalidLink-model">

  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-body p-4 text-center">
        <h5 class="font-weight-bolder mb-3 text-danger"><strong> Invalid Link</strong></h5>
        <p class="mb-0">The link is invalid. Please check the URL and try again.</p>
      </div>
    </div>
  </div>
</div>









